export default __webpack_public_path__ + "static/media/banner_videos.ab8aee4d.jpg";